import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardDescription, 
  CardContent, 
  CardFooter 
} from "@/components/academician/card"
import { Button } from "@/components/ui/button"
import { HeartIcon, ShareIcon, BookmarkIcon, TrendingUpIcon, UsersIcon, ActivityIcon } from "lucide-react"

export function HomePage() {
  const stats = [
    { title: "Total Users", value: "2,543", change: "+12%", icon: UsersIcon },
    { title: "Active Now", value: "847", change: "+5%", icon: ActivityIcon },
    { title: "Growth", value: "23%", change: "+8%", icon: TrendingUpIcon },
  ]

  const posts = [
    {
      id: 1,
      title: "Getting Started with React",
      description: "Learn the basics of React development",
      content: "React is a powerful library for building user interfaces. This guide will help you understand the core concepts and get started with your first project.",
      date: "2 days ago",
      likes: 42
    },
    {
      id: 2,
      title: "TypeScript Best Practices",
      description: "Write better TypeScript code",
      content: "Discover essential TypeScript patterns and practices that will make your code more maintainable, type-safe, and easier to work with.",
      date: "5 days ago",
      likes: 38
    },
    {
      id: 3,
      title: "Modern CSS Techniques",
      description: "Advanced styling with Tailwind",
      content: "Explore modern CSS approaches using Tailwind CSS. Learn how to create responsive, beautiful designs with utility-first CSS.",
      date: "1 week ago",
      likes: 56
    }
  ]

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 space-y-8">
        {/* Hero Section */}
        <div className="text-center space-y-4 py-12">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground">
            Welcome to Card Showcase
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our beautiful card component in action with various layouts and use cases
          </p>
        </div>

        {/* Stats Cards */}
        <div>
          <h2 className="text-2xl font-semibold text-foreground mb-6">Statistics</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {stats.map((stat) => (
              <Card key={stat.title} hoverable>
                <div className="flex items-start justify-between">
                  <div className="space-y-2">
                    <p className="text-sm text-muted-foreground">{stat.title}</p>
                    <p className="text-3xl font-bold text-foreground">{stat.value}</p>
                    <p className="text-sm text-green-600 dark:text-green-400">
                      {stat.change} from last month
                    </p>
                  </div>
                  <div className="p-3 bg-primary/10 rounded-lg">
                    <stat.icon className="h-6 w-6 text-primary" />
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Featured Posts */}
        <div>
          <h2 className="text-2xl font-semibold text-foreground mb-6">Featured Posts</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
              <Card key={post.id} hoverable>
                <CardHeader>
                  <CardTitle className="text-xl">{post.title}</CardTitle>
                  <CardDescription>{post.description}</CardDescription>
                </CardHeader>
                <CardContent className="pt-4">
                  <p className="text-sm text-foreground line-clamp-3">
                    {post.content}
                  </p>
                </CardContent>
                <CardFooter className="pt-4 justify-between">
                  <div className="flex gap-2">
                    <Button size="icon" variant="ghost">
                      <HeartIcon className="h-4 w-4" />
                    </Button>
                    <Button size="icon" variant="ghost">
                      <ShareIcon className="h-4 w-4" />
                    </Button>
                    <Button size="icon" variant="ghost">
                      <BookmarkIcon className="h-4 w-4" />
                    </Button>
                  </div>
                  <span className="text-sm text-muted-foreground">{post.date}</span>
                </CardFooter>
              </Card>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="py-12">
          <Card hoverable className="max-w-3xl mx-auto">
            <div className="text-center space-y-4">
              <h3 className="text-2xl font-bold text-foreground">
                Ready to Get Started?
              </h3>
              <p className="text-muted-foreground">
                Join thousands of developers building amazing applications with our components
              </p>
              <div className="flex gap-4 justify-center pt-4">
                <Button size="lg">Get Started</Button>
                <Button size="lg" variant="outline">Learn More</Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}